import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import { INVOICE_PAYOR_TYPE_LIST_REQUEST, INVOICE_PAYOR_TYPE_LIST_RECEIVED, INVOICE_PAYOR_TYPE_LIST_ERROR } from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

export const invoicePayorTypeListRequest = () => ({
  type: INVOICE_PAYOR_TYPE_LIST_REQUEST,
});

export const invoicePayorTypeListReceived = (data) => ({
  type: INVOICE_PAYOR_TYPE_LIST_RECEIVED,
  data,
});

export const invoicePayorTypeListError = (error) => ({
  type: INVOICE_PAYOR_TYPE_LIST_ERROR,
  error,
});

export const invoicePayorTypeListFetch = () => {
  return (dispatch) => {
    dispatch(invoicePayorTypeListRequest());
    const filters = { pagination: false };
    return requests
      .get(API_ROUTES.INVOICE_PAYOR_TYPE, filters)
      .then((response) => dispatch(invoicePayorTypeListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(invoicePayorTypeListError(error));
      });
  };
};
